// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"295":"batchquery","535":"login","596":"404","945":"mainlayout"}[chunkId] || chunkId) + "." + {"134":"3a4b7200","295":"a429820d","394":"f37c1ef8","535":"ae23325d","596":"7fd0c26d","945":"4421cf03"}[chunkId] + ".js";
};